module.exports = __webpack_public_path__ + "img/electroplating-equipments.6ad537b4.webp";